import React from "react";
import { ArrowRight, Heart, HandHeart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringSocietyThroughService() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38849" id="transforming-lives-through-education" className="relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden bg-background text-foreground sm:min-h-screen">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://farquharfisherfoundation.co.uk/wp-content/uploads/2026/03/15.jpeg)] bg-cover bg-center bg-no-repeat" aria-hidden="true" />
        <div className="absolute inset-0 bg-background/55" />
        
      </div>

      <div ref={ref} className={cn("relative z-10 container mx-auto flex flex-col items-center px-4 text-center transition-all duration-1000 ease-out sm:px-6", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        <div className="mx-auto max-w-4xl">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-secondary/10 px-4 py-2 text-sm font-semibold text-secondary backdrop-blur-sm">
            <HandHeart className="h-4 w-4" />
            Supporting education and opportunity in Ghana
          </div>

          <h1 className="text-4xl font-bold tracking-tight text-primary sm:text-5xl md:text-6xl lg:text-7xl">
            Transforming lives through education
          </h1>

          <p className="mx-auto mt-5 max-w-3xl text-base leading-7 text-foreground/85 sm:text-lg sm:leading-8 md:text-xl">
            We are committed to helping children and communities in Ghana
            through practical projects that improve access to education,
            technology, and opportunity.
          </p>
        </div>

        <div className="mt-8 flex w-full flex-col gap-4 sm:mt-10 sm:w-auto sm:flex-row">
          <Link to="/DonatePage" className="w-full sm:w-auto">
            <Button size="lg" className="h-12 w-full rounded-xl bg-secondary px-8 text-base font-semibold text-secondary-foreground shadow-lg transition-all hover:bg-secondary/90 hover:shadow-xl sm:w-auto">
              <Heart className="mr-2 h-4 w-4 fill-current" />
              Donate Now
            </Button>
          </Link>

          <Link to="/ContactPage" className="w-full sm:w-auto">
            <Button variant="ghost" size="lg" className="h-12 w-full rounded-xl border-2 border-primary/20 bg-primary/5 px-8 text-base font-semibold text-primary backdrop-blur-sm transition-all duration-300 hover:scale-[1.02] hover:border-primary hover:bg-primary/10 hover:text-primary sm:w-auto">
              <HandHeart className="mr-2 h-4 w-4" />
              Become a Volunteer
            </Button>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 hidden -translate-x-1/2 animate-bounce md:block">
        <ArrowRight className="h-6 w-6 rotate-90 text-primary/50" />
      </div>
    </section>;
}